module.exports = __webpack_public_path__ + "media/assets/icons/envelope-letter-5d6b6574ba9f21fd9970a1f490ea30af.svg";